import React from 'react';
import PropTypes from 'prop-types';
import { INFO_COLOR } from '../../../../styles/variables';
import AddIcon from '../../../Icons/AddIcon';
import { AddStep, AddonBox } from '../../style';

const AddNewStep = ({ addStep, isDragging }) => {
  return (
    <AddonBox
      onClick={e => (isDragging ? e.preventDefault() : addStep())}
      size={4}
      center
      className="add-new-step"
    >
      <AddStep>
        <AddIcon color={INFO_COLOR} width="30px" height="30px" />
        <p>Novo Passo</p>
      </AddStep>
    </AddonBox>
  );
};

AddNewStep.propTypes = {
  addStep: PropTypes.func.isRequired,
  isDragging: PropTypes.bool,
};

export default AddNewStep;



// WEBPACK FOOTER //
// ./src/components/ProductAddons/CustomSteps/AddNewStep/index.js